import { Message } from 'element-ui';
import { signContractInfo } from "@/service/econtract";
import { getListUrl } from "@/service/totodi";
import { CONTRACT_TYPE_PAPER, CONTRACT_TYPE_ELECTRON, PAPER_SUBMISSION } from '@/common/reservation';

// 跳转认申购签署合同
export const jumpSignContract = async (apply_id) => {
  const resData = await signContractInfo({apply_id});
  const param = resData.data;
  let url = `${window.location.origin}/reservationSuccess?type=signContractSuccess`;
  if (param.skip_subscription) {
    // true 跳过预约
    delete param.skip_subscription;
    url = `${window.location.origin}/reservationSuccess?type=skipSubscription`;
  }
  const signUrl = getListUrl({
    ...resData.data,
    redirect_uri: url,
  })
  
  window.location.href = signUrl;
}


// 电子合同步骤列表
export const getElectronStepList = (data) => {
  const {
    step_list,
    step_type,
    electron_paper,
  } = data;
  const newList = [
    {name: '确认个人信息', path: '/purchaseConfirmInfo'},
    {name: '填写预约信息', path: '/purchaseFillInfo'},
    {name: '验证身份信息', path: '/identityVerification'},
  ];
  // 纸质合同
  if (electron_paper === CONTRACT_TYPE_PAPER) {
    const dualRecordData = step_list.find(i => i.cn_name === 'dualRecord') || {};
    console.log(dualRecordData, 'isDualRecord=====', step_list)
    if (dualRecordData.status !== -1) {
      newList.push({name: '录音录像确认', path: '/pdfRecord'})
    }
    // 申购完成页和认购完成页
    newList.push({name: '提交预约', path: PAPER_SUBMISSION})
  }
  // 电子合同
  if (electron_paper === CONTRACT_TYPE_ELECTRON) {
    const signed = (step_list.find(i => i.cn_name === 'setSignature') || {}).status !== -1;
    // 判断设置电子签名
    if (signed) {
      newList.push({name: '设置电子签名', path: '/setSignature'})
    }
    // 签署适当性文件
    if ([1, 4].includes(step_type)) {
      newList.push({name: '签署适当性文件', path: '/uploadFile'})
    }
    // 审核适当性文件
    if ([3].includes(step_type)) {
      newList.push({name: '审核适当性文件', path: ''})
    }
    newList.push({name: '签署认/申购文件', path: '/pdfRecord'})
    newList.push({name: '打款确认', path: '/makePayment'})
    newList.push({name: '冷静期', path: '/'})
    newList.push({name: '回访确认', path: '/returnVisit'})
    newList.push({name: '份额确认', path: '/'})
  }
  return newList
}

// querySteps接口数据存储处理获取预约步骤信息
export const getStepsData = (data) => {
  const { step_list } = data;
  //  -1:无需进行 0:待处理 1:已完成
  const isSetSignature = (step_list.find(i => i.cn_name === 'setSignature') || {}).status === 1;
  const isPassWord = (step_list.find(i => i.cn_name === 'setPassword') || {}).status === 1;
  const isUploadCertFile = (step_list.find(i => i.cn_name === 'uploadCertFile') || {}).status === 0;
  // const isSignAptnessDoc = (step_list.find(i => i.cn_name === 'signAptnessDoc') || {}).status === 0;
  const isDualRecord = (step_list.find(i => i.cn_name === 'dualRecord') || {}).status === 0;
  const isBasicInformation = (step_list.find(i => i.cn_name === 'resetBasicInfo') || {}).status === 0;
  // const isSignContract = (step_list.find(i => i.cn_name === 'signContract') || {}).status === 0;

  return {
    review_flag: data.review_flag,
    step_list,
    check_cfca: data.check_cfca === 1 ? true : false,
    check_bjca: data.check_bjca === 1 ? true : false,
    electron_paper: data.electron_paper,
    cfca_state: data.cfca_state,
    step_type: data.step_type,
    stepList: getElectronStepList(data),
    // 是否完成签名图片
    isSetSignature,
    // 是否完成签名密码
    isPassWord,
    // 是否需要上传资质证明文件
    isUploadCertFile,
    // 签署适当性文件
    // isSignAptnessDoc,
    // 是否双录
    isDualRecord,
    // 是否签署认申购合同
    // isSignContract,
    //  签署签名图片的提示 true:提示签名同步 false:不提示
    tip_sign_image: data.tip_sign_image,
    // 是否需要重新确认投资者基本信息表
    isBasicInformation, 
  }
}

// 点击复制文本
export const copyText = (text, isMobile) => {
  let domInput = document.createElement('input');
  domInput.value = text;
  document.body.appendChild(domInput);  // 添加input节点
  domInput.select(); // 选择对象;
  document.execCommand("Copy"); // 执行浏览器复制命令
  Message.closeAll()
  if (!isMobile) {
    Message({
      type: 'success',
      customClass: 'electron-message-pc',
      message: '复制成功'
    });
  } else {
    Message({
      type: 'success',
      dangerouslyUseHTMLString: true,
      customClass: 'electron-message',
      message: '复制成功'
    });
  }
  domInput.remove()
}

// 获取结束时间
export const getEndTime = (date) => {
  const now = new Date().getTime();
  if (!date) return '';
  const endTime = new Date(date).getTime();
  const distance = endTime - now;
  // 如果倒计时结束，清除定时器并返回提示
  if (distance <= 0) {
    return '';
  }
  
  // 将剩余时间转换为时、分、秒
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}